import React from 'react';
import mission from "../assets/HomePage/aboutus/pexels-valeriiamiller-5403400.jpg";
import version from "../assets/HomePage/aboutus/pexels-pixabay-532543.jpg";


const MissionVisionCallout: React.FC = () => {
  return (
    <div className="relative w-full max-w-[1400px] mx-auto overflow-hidden px-4 sm:px-6 lg:px-8 py-12">
      <div className="space-y-24">
        {/* Our Mission Section */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
          {/* Content - Left on desktop, top on mobile */}
          <div className="flex flex-col justify-center order-2 md:order-1">
            <div className="mb-3 text-sm font-bold text-primaryAlt break-words opacity-70">
              Our Project
            </div>

            {/* Title with proper text wrapping */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primaryAlt mb-4 sm:mb-8 break-words leading-tight">
              Our Mission
            </h2>

            {/* Content area with overflow handling */}
            <div className="text-base sm:text-lg text-primaryAlt max-w-full break-words">
              <p className="mb-4 overflow-wrap-anywhere hyphens-auto">
                To protect koalas through innovative photo identification technology. We build a comprehensive koala database using citizen-contributed images, enabling effective monitoring and informed conservation decisions.
              </p>
            </div>
          </div>

          {/* Image - Right on desktop, bottom on mobile */}
          <div className="order-1 md:order-2">
            <div className="aspect-[4/3] overflow-hidden rounded-lg shadow-md">
              <img
                src={mission}
                alt="Our Mission"
                className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>
        </div>

        {/* Our Vision Section - Reversed layout on desktop */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
          {/* Content - Right on desktop, top on mobile */}
          <div className="flex flex-col justify-center order-2 md:order-2">
            <div className="mb-3 text-sm font-bold text-primaryAlt break-words opacity-70">
              Our Aspiration
            </div>

            {/* Title with proper text wrapping */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primaryAlt mb-4 sm:mb-8 break-words leading-tight">
              Our Vision
            </h2>

            {/* Content area with overflow handling */}
            <div className="text-base sm:text-lg text-primaryAlt max-w-full break-words">
              <p className="mb-4 overflow-wrap-anywhere hyphens-auto">
                A world where every koala can be identified, tracked, and protected through our collaborative platform. We connect citizens, scientists, and conservationists to ensure koalas thrive for future generations.
              </p>
            </div>
          </div>

          {/* Image - Left on desktop, bottom on mobile */}
          <div className="order-1 md:order-1">
            <div className="aspect-[4/3] overflow-hidden rounded-lg shadow-md">
              <img
                src={version}
                alt="Our Vision"
                className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionVisionCallout;